import"../../core/enums.js";var O;(function(O){O[O["BOTTOM"]=6]="BOTTOM";O[O["TOP"]=5]="TOP"})(O||(O={}));export{O as ESelectVerticalAlign};
//# sourceMappingURL=enums.js.map
